//langs/index.js
// 整站英文暂下线：只注册中文语言包（需要英文站时再补 en 回来）

import zh from './zh'
export default {
  zh
}
